import { mockDataUtil } from './mockDataUtil';
import { getItemLocationRelationshipPage } from '../mock/itemLocationRelationshipData';
import { API_ENDPOINTS } from '../utils/apiEndpoints';
import httpClient from './httpClient';
import { 
  ItemLocationRelationship, 
  ItemLocationRelationshipFilters, 
  ItemLocationRelationshipPaginationParams,
  ItemLocationRelationshipPagingResponse
} from '../types/item-location-relationship';
import { WHOLE_USE_MOCK } from './api';

// 通用API响应格式
interface ApiResponse<T> {
  success: boolean;
  data: T;
  errorMessage?: string;
  traceId?: string;
  flag: string;
}

class ItemLocationRelationshipService {
  // 是否使用模拟数据
  async getMock(): Promise<boolean> {
    return true;
  }

  /**
   * 获取货品库位关系分页列表
   * @param filters 过滤条件
   * @param paginationParams 分页参数
   * @returns 分页数据
   */
  async getItemLocationRelationships(
    filters: ItemLocationRelationshipFilters = {},
    paginationParams: ItemLocationRelationshipPaginationParams
  ): Promise<ApiResponse<ItemLocationRelationshipPagingResponse>> {
    if (await this.getMock() && WHOLE_USE_MOCK) {
      const pageData = getItemLocationRelationshipPage(filters, {
        currentPage: paginationParams.currentPage,
        pageSize: paginationParams.pageSize
      });

      // 应用排序
      if (paginationParams.sortBy && paginationParams.sortOrder) {
        pageData.tableData.sort((a, b) => {
          const field = paginationParams.sortBy!;
          let aValue = a[field as keyof ItemLocationRelationship];
          let bValue = b[field as keyof ItemLocationRelationship];

          // 处理不同类型的字段排序
          if (typeof aValue === 'string' && typeof bValue === 'string') {
            aValue = aValue.toLowerCase();
            bValue = bValue.toLowerCase();
          }

          if (paginationParams.sortOrder === 'asc') {
            return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
          } else {
            return aValue < bValue ? 1 : aValue > bValue ? -1 : 0;
          }
        });
      }

      const response = await mockDataUtil.mockPageRes(pageData.tableData, pageData.paging);
      return response as unknown as ApiResponse<ItemLocationRelationshipPagingResponse>;
    } else {
      const searchParams = {
        ...filters,
        ...paginationParams
      };
      const res = await httpClient.post(API_ENDPOINTS.ITEM_LOCATION_RELATIONSHIP.PAGE, searchParams);
      return res.data;
    }
  }

}

export const itemLocationRelationshipService = new ItemLocationRelationshipService();